module.exports = __webpack_public_path__ + "img/check-circle-green.08701737.svg";